import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import { Provider } from "react-redux";
import ReactDOM from "react-dom";
import { createBrowserHistory } from "history";
import { ConnectedRouter } from "connected-react-router";
import configureStore from "./store/configureStore";
import App from "./App";
import "./util/LanguageSupport/i18nLanguage";

import { unregister } from "./registerServiceWorker";

import { PersistGate } from "redux-persist/integration/react";
import "react-phone-number-input/style.css";

const baseUrl = document.getElementsByTagName("base")[0].getAttribute("href") as string;
const rootElement = document.getElementById("root");
const history = createBrowserHistory({ basename: baseUrl });
const { store, persistor } = configureStore(history);

ReactDOM.render(
    <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
            <ConnectedRouter history={history}>
                <App />
            </ConnectedRouter>
        </PersistGate>
    </Provider>,
    rootElement
);

unregister();
